import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import OfferOrderService from '../services/offer.service';
import { OFFERS_LIST_KEY } from '../constants/offer.queries';

export const useCloneOffer = (offerId: string, onClose?: () => void) => {
  const { t } = useTranslation('offerOrder');
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutate, isPending, error } = useMutation(() => OfferOrderService.clone(offerId), {
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [OFFERS_LIST_KEY] });
      toast.success(t('clone.success'));
      onClose?.();
      data?._id && navigate(`/sales/offers/settings/offer_orders/${data._id as string}/general`);
    },
  });

  return { mutate, isPending, error };
};
